import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import ApplicationLayout from 'v3/layouts/Application';
import { useSnackbar } from 'v3/components/Snackbar';
import Space from 'v3/components/Space';
import Button from 'v3/components/Button';
import Text from 'v3/components/Text';
import { validatePermission } from 'actions/index';
import IntegrationLogs from 'v3/components/IntegrationLogs';
import Data from './Data';
import PaymentMethod from './PaymentMethod';
import Certificate from './Certificate';
import LastTravels from './LastTravels';
import Address from '../shared/Address';
import AttachedDrivers from '../shared/AttachedDrivers/index';
import AttachedVehicles from '../shared/AttachedVehicles';
import Attachments from './Attachments';
import BennerStatus from './BennerStatus';
import RequestInfo from './RequestInfo';
import RequestStatusCard from './RequestStatusCard';
import { useShippingCompany } from '../shared/context';

export default function ShippingCompanyDetails() {
  const shippingCompany = useShippingCompany();

  const [attachments, setAttachments] = useState([]);
  const hasPermissionToCreate = validatePermission('CADASTRAR_TRANSPORTADORA');

  const snackbar = useSnackbar();
  useEffect(() => {
    snackbar.show(
      <Text>
        Alterações de dados cadastrais devem ser solicitadas na viagem no card "Solicitação de
        Ajuste de Cadastro".
      </Text>,
      { type: 'warning' },
    );
  }, []);

  return (
    <ApplicationLayout
      title="Transportadora"
      RightComponent={
        <Space x="4px">
          <Link to="/transportadoras">
            <Button variant="secondary">
              <Text color="dark" weight={500} type="regular">
                Voltar
              </Text>
            </Button>
          </Link>

          {hasPermissionToCreate && (
            <Link to="/transportadoras/cadastrar">
              <Button>
                <Text color="white" weight={500} type="regular">
                  Nova transportadora
                </Text>
              </Button>
            </Link>
          )}
        </Space>
      }
    >
      <Row>
        <Col xs={12}>
          <RequestStatusCard />
        </Col>
        <Col xs={12} md={6}>
          <Data />
          <RequestInfo />
          <PaymentMethod />
          <Certificate />
        </Col>
        <Col xs={12} md={6}>
          <Address />
          <AttachedVehicles />
          <BennerStatus />
        </Col>
        <Col md={12}>
          <AttachedDrivers />
          <LastTravels />
        </Col>
        {shippingCompany.data?.shippingCompanies?.id && (
          <Col md={12}>
            <IntegrationLogs
              entity="shippingCompany"
              entityId={shippingCompany.data.shippingCompanies.id}
            />
          </Col>
        )}
        <Col md={12}>
          <Attachments attachments={attachments} setAttachments={setAttachments} />
        </Col>
      </Row>
    </ApplicationLayout>
  );
}
